module.exports = __webpack_public_path__ + "static/media/ruler.8c1eeac6.png";